{
  "#ABC_ANALYSIS": {
    "APP_TITLE": "ABC Analyse",
    "STORAGE_SELECTION": {
      "SUBTITLE": "Lagerplatz auswählen",
      "MENU_ITEM": "Lagerplatz Auswahl"
    },
    "STORAGE_LOCATION_HEADER": {
      "CATEGORY": "Segment",
      "STORAGE_LOCATION": "Lagerplatz",
      "CONFIGURATION": "Analyse Variante"
    },
    "CATEGORY_SELECTION": {
      "SUBTITLE": "Segment auswählen",
      "MENU_ITEM": "Segment Auswahl",
      "PIE_CHART_TITLE": "Artikel-Verteilung nach Segmenten",
      "CHANGE_ESL": "ESL Umschalten",
      "FLASH_ESL": "ESL Blinken",
      "BUTTONS": {
        "ARTIKEL": "Artikel-Verteilung",
        "DECKUNGSBEITRAG": "Deckungsbeitrag-Verteilung",
        "NETTO": "Netto-Verteilung",
        "LAGERWERT": "Lagerwert-Verteilung"
      }
    },
    "CATEGORY_CARD": {
      "CATEGORY": "Segment",
      "PRODUCTS": "Artikel",
      "OF": "von",
      "CONTRIBUTION_MARGIN": "DB",
      "NET": "Netto",
      "STOCK_VALUE": "Lagerwert",
      "STOCK_QUANTITY": "Lagermenge",
      "STOCK_UNIT": "Einheiten"
    },
    "PRODUCT_CARD": {
      "SUPPLIER": "Lieferant",
      "PRODUCT_DETAILS": "Artikeldetails",
      "UNIT": "Einheit",
      "CONTRIBUTION_MARGIN": "DB",
      "NET": "Netto",
      "STOCK_UNIT": "Lager-Einheit",
      "STOCK_QUANTITY": "Lagermenge",
      "STOCK_VALUE": "Lagerwert",
      "SINGLE_PRICE": "Einzelpreis",
      "LOCATION": "Standort"
    },
    "CATEGORY_DETAIL": {
      "SUBTITLE": "Artikelübersicht",
      "MENU_ITEM": "Artikelübersicht",
      "CHANGE_ESL": "ESL Umschalten",
      "FLASH_ESL": "ESL Blinken"
    },
    "CONFIGURATION": {
      "SUBTITLE": "Konfiguration",
      "MENU_ITEM": "Konfiguration",
      "SETTINGS_TITLE": "ABC Analyse",
      "HEADER_TITLE": "ABC-Analyse einrichten",
      "HEADER_SUBTITLE": "Bitte füllen Sie das Eingabefeld aus, um die ABC-Analyse zu konfigurieren.",
      "LABEL": "Analyse Variante",
      "PLACEHOLDER": "Bitte wählen Sie eine Variante aus"
    },
    "GUARD": {
      "MULTI_CONFIG": "Mehrere ABC-Konfigurationen vorhanden, bitte wählen Sie eine aus.",
      "NO_CONFIG": "Keine ABC-Konfiguration vorhanden."
    },
    "NO_DATA": {
      "TITLE": "Keine Daten vorhanden!",
      "SUBTITLE": "Für den ausgewählten Lagerplatz wurden keine Segmente gefunden.",
      "SUBTITLE2": "Bitte überprüfen Sie ob der Lagerplatz Artikel enthält."
    },
    "SERVICE": {
      "QUANTITY": "Artikel-Verteilung nach Segmenten",
      "CONTRIBUTION_MARGIN": "Deckungsbeitrag-Verteilung nach Segmenten",
      "NET": "Netto-Verteilung nach Segmenten",
      "STOCK_VALUE": "Lagerwert-Verteilung nach Segmenten",
      "PRODUCT": "Artikel"
    }
  }
}
